export default "__VITE_ASSET__ff8d7fdc__"